import { Col, Divider, Row, Typography } from "antd"
import { ApprovedPerVisitPaymentSummary } from "../../../domain/proposals/paymentSummary"
import PaymentSection from "./PaymentSection"
import dayjs from "dayjs"
import { centsToDollarsDisplay } from "../../displayFormatters"
import { WorkareaGroup } from "../../../domain/workareas/group"

type Props = {
  summary: ApprovedPerVisitPaymentSummary
  workareaGroups: WorkareaGroup[]
}

const PerVisit = ({summary, workareaGroups}: Props) => {
  const divider = <Divider style={{margin: '8px 0 8px 0'}}/>

  const getWorkareaGroupName = (id: string) => {
    const group = workareaGroups.find(x => x.id === id)
    return group ? group.name : ''
  }

  return <PaymentSection title="Per Visit Invoicing Schedule">
    {summary.perVisitGroups.map((group) => <div key={group.workareaGroupId}>
      <Row>
        <Col span={12}><strong>{getWorkareaGroupName(group.workareaGroupId)}</strong></Col>
        <Col span={12} style={{textAlign: 'right'}}>{centsToDollarsDisplay(group.amount)} per visit</Col>
      </Row>
      {group.estimatedSalesTax > 0 && <Row>
        <Col span={24} style={{textAlign: 'right'}}>
          <Typography.Text type="secondary">
            {centsToDollarsDisplay(group.estimatedSalesTax + group.amount)} with sales tax
          </Typography.Text>
        </Col>
      </Row>}
      {divider}
    </div>)}
    <div>{summary.scheduleText}</div>
    {summary.startDate && <Typography.Text type="secondary">Starting {dayjs(summary.startDate).format('MMM D, YYYY')}</Typography.Text>}
  </PaymentSection>
}

export default PerVisit